import { render, staticRenderFns } from "./UploadFormAnnexure.vue?vue&type=template&id=9b59884e&scoped=true"
import script from "./UploadFormAnnexure.vue?vue&type=script&lang=js"
export * from "./UploadFormAnnexure.vue?vue&type=script&lang=js"
import style0 from "./UploadFormAnnexure.vue?vue&type=style&index=0&id=9b59884e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b59884e",
  null
  
)

export default component.exports